<template>
  <div class="default-layout">
    <SiteNavbar class="mb-5" />
    <b-row class="no-gutters justify-content-center container-fluid my-5">
      <b-col cols="12" md="6" sm="10">
        <SiteContent />
      </b-col>
    </b-row>
    <SiteFooter class="site-footer" />
  </div>
</template>

<script>
/**
 * @file       Layout default component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";

import SiteNavbar from "@/layouts/components/siteNavbar.vue";
import SiteContent from "@/layouts/components/siteContent.vue";
import SiteFooter from "@/layouts/components/siteFooter.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "DefaultLayout",
  components: {
    SiteContent,
    SiteNavbar,
    SiteFooter
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      ifAuthenticated: state => !!state.auth.profile.data
    })
  }
};
</script>
